import React from "react";

function Terms() {
  return (
    <div className="terms section">
      <h2 className="termsHeader">Terms & Conditions</h2>
      <p className="termsText">
        By downloading and using the GistGate News Application, you agree to the
        following terms Content: <br />
        <br />
        <br /> That you understand that GistGate Media Intl, will not be held
        liable for any damages caused by using the information you get through
        this app. <br />
        <br />
        That you understand that the various news agencies or website owners
        reserve the rights to their contents and that GistGate does not interfer
        with the news derived from such sources. <br />
        <br />
        That the respective websites reserve the rights to their brandings
        (logos, names etc) as well as the contents that they publish and the
        media they publish and that GistGate will not be held responsible for
        such Modifications: <br />
        <br />
        You agree that that you understand that GistGate can make modifications
        to this app and any other of its products or services without prior
        information to the users and that gistgate will not be held responsible
        for any damages that such changes may do to the users. <br />
        <br />
        Data usage and advertisement: <br />
        <br />
        You agree that GistGate media and our partners may collect some data
        from the device or devices on which this Application is hosted for
        purposes of marketing or ads personalization. <br />
        <br />
        We will never collect any specific personal data that is indiviually
        linked such as contact details, device monitoring, passwords, credit
        card information and other such information without express permission
        from you. <br />
        <br />
        The app must be used in accordance with all applicable laws and
        regulations. The app may not be used in any way that is illegal,
        fraudulent, or malicious. <br />
        <br />
        The app may not be used to distribute or transmit any content that is
        offensive, threatening, harassing, or otherwise inappropriate. <br />
        <br />
        The app may not be used to collect or share any personal information
        without the express consent of the individual concerned. <br />
        <br />
        The app may not be used to access, modify, or delete any data or
        information without the proper authorization. The app may be updated or
        modified at any time, and it is the user's responsibility to ensure that
        they are using the latest version. By using this app, the user agrees to
        be bound by these terms and conditions. <br />
        <br />
        Any violation of this policy may result in the termination of the user's
        access to the app. <br />
        <br />
        Build version v1.0.0 Last updated: 15th Dec. 2022
      </p>
    </div>
  );
}

export default Terms;
